export default __webpack_public_path__ + "static/media/eye-open.inline.60d9da4d.svg";